import './Addendum.scss'

export default ({children}) => {
    return (
        <div className='dashboard-addendum'>
            {children}
        </div>
    )
}